(function () {
  'use strict';
  var now = Date.now() / 1000;
  document.querySelectorAll('[data-nh-bn]').forEach(function (banner) {
    var start = Number(banner.getAttribute('data-start'));
    var end = Number(banner.getAttribute('data-end'));
    if (now >= end) {
      var home = banner.closest('.nh-bn-home');
      (home || banner).remove();
      return;
    }
    if (now < start) return;
    var href = banner.getAttribute('data-css');
    if (!href || document.querySelector('link[data-nh-bn-css]')) {
      banner.hidden = false;
      return;
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-nh-bn-css', '');
    link.onload = function () { banner.hidden = false; };
    document.head.appendChild(link);
  });
})();
